import React from "react";
import { Col, Container, Row } from "reactstrap";
import JobDetailsDescription from "./JobDetailsDescription";
import { useParams, Navigate } from "react-router-dom";
// import JobVacancyPost from "./JobVacancyPost";
import RightSideContent from "./RightSideContent";
// import Section from "./Section";

const JobDetails = () => {
  const { id } = useParams();
  if (!id) {
    return <Navigate to="/jobgrid" replace />;
  }
  localStorage.setItem("jobs", id);
  document.title = "Avaza Empleos | Categotias de empleo";
  return (
    <React.Fragment>
      {/* <Section /> */}
      <section className="section">
        <Container>
          <Row>
            <Col lg={8}  style={{paddingTop:"48px"}}>
              <JobDetailsDescription jobId={id}/>
              {/* <JobVacancyPost /> */}
            </Col>
            <Col lg={4} className="mt-4 mt-lg-0">
              <RightSideContent jobId={id}/>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobDetails;
